/* HOMIRA v8 — product gallery shows only the selected colour (plus shared lifestyle images). */
(function(){
  function init(){
    var root=document.querySelector('[data-hm-variants]'); if(!root) return;
    var json=root.querySelector('[data-hm-variant-json]'); if(!json) return;
    var variants; try{variants=JSON.parse(json.textContent)}catch(e){return}
    var mains=[].slice.call(root.querySelectorAll('[data-hm-main]'));
    var thumbs=[].slice.call(root.querySelectorAll('[data-hm-thumb]'));
    if(!mains.length) return;
    var colourIdx=null, colourWrap=null;
    root.querySelectorAll('[data-hm-option-index]').forEach(function(w){ if(w.querySelector('.hm-sw') && colourWrap===null){colourWrap=w;colourIdx=+w.getAttribute('data-hm-option-index');} });
    if(colourIdx===null) return;
    var byColour={}, owned={};
    variants.forEach(function(v){ if(v.featured_media_position==null) return; var c=v.options[colourIdx]; byColour[c]=v.featured_media_position; owned[v.featured_media_position]=true; });
    var counter=root.querySelector('[data-hm-counter]');
    function current(){ var r=colourWrap.querySelector('input:checked'); return r?r.value:null; }
    function visible(i){ return !owned[i] || i===byColour[current()]; }
    function shown(){ for(var i=0;i<mains.length;i++){ if(mains[i].style.display!=='none') return i; } return 0; }
    function apply(){
      var list=[]; mains.forEach(function(m,i){ if(visible(i)) list.push(i); });
      thumbs.forEach(function(t,i){ t.style.display=visible(i)?'':'none'; });
      var s=shown(); if(!visible(s)){ var target=byColour[current()]; if(target==null) target=list[0]; show(target); s=target; }
      if(counter){ counter.textContent=(list.indexOf(s)+1)+' / '+list.length; }
      return list;
    }
    function show(i){ if(thumbs[i]) thumbs[i].click(); else { mains.forEach(function(m,j){m.style.display=j===i?'block':'none';}); } }
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-hm-gal-step]'); if(!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var list=apply(), s=shown(), p=list.indexOf(s), step=+b.getAttribute('data-hm-gal-step');
      var n=list[(p+step+list.length)%list.length]; show(n); setTimeout(apply,0);
    },true);
    root.addEventListener('click',function(e){ if(e.target.closest('[data-hm-thumb]')) setTimeout(apply,0); });
    colourWrap.addEventListener('change',function(){ setTimeout(function(){ var t=byColour[current()]; if(t!=null) show(t); apply(); },30); });
    apply();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* HOMIRA v8.1 — launch countdown to a fixed end date (29 Nov 2026, 23:59 UK). */
(function(){
  var END=Date.UTC(2026,10,30,0,0,0);
  function init(){
    if(Date.now()>=END) return;
    var root=document.querySelector('[data-hm-variants]'); if(!root) return;
    var note=[].slice.call(root.querySelectorAll('div')).find(function(d){return d.children.length===0 && /^Launch price until/.test(d.textContent.trim());});
    if(!note || root.querySelector('.hm-countdown')) return;
    var box=document.createElement('div'); box.className='hm-countdown';
    box.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7.5V12l3 2"></path></svg><span>Launch price ends in <strong data-hm-cd></strong></span>';
    note.parentNode.insertBefore(box,note.nextSibling);
    var out=box.querySelector('[data-hm-cd]');
    function p(n){return (n<10?'0':'')+n}
    function tick(){var s=Math.max(0,Math.floor((END-Date.now())/1000)); if(!s){box.remove();return;} var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),x=s%60; out.textContent=d+'d '+p(h)+'h '+p(m)+'m '+p(x)+'s';}
    tick(); setInterval(tick,1000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* HOMIRA v9 — set picker: coloured badges + "Save £X" per set */
(function(){
  function num(t){var m=(t||'').replace(/,/g,'').match(/[\d.]+/);return m?parseFloat(m[0]):0}
  function init(){
    document.querySelectorAll('.hm-set').forEach(function(s){
      var b=s.querySelector('.hm-set__badge'); if(b && /best/i.test(b.textContent)) b.classList.add('hm-badge-best');
      if(s.querySelector('.hm-set__save')) return;
      var was=num((s.querySelector('.hm-set__price s')||{}).textContent), now=num((s.querySelector('.hm-set__price strong')||{}).textContent);
      var main=s.querySelector('.hm-set__main'); if(!main||!(was>now)) return;
      var d=Math.round(was-now), el=document.createElement('span'); el.className='hm-set__save'; el.textContent='Save £'+d; main.appendChild(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
